import styled from 'styled-components'
import Education from '../../../../../images/icons/resume/education.svg'

export const CardIcon = styled(Education)``
